import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NotificationContainerView } from './container_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const PushNotificationPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return (_jsx(NotificationContainerView, { children: _jsx("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                backgroundColor: 'rgb(226,225,225)',
                borderRadius: 'calc(1rem - 4px)',
                padding: '2rem 1rem',
                overflowY: 'auto',
            }, children: _jsxs("div", { style: {
                    display: 'flex',
                    background: '#fff',
                    maxWidth: '360px',
                    alignSelf: 'center',
                    alignItems: 'center',
                    padding: '1em 1em 1em 0.5em',
                    borderRadius: '5px',
                    width: '100%',
                }, children: [_jsx("div", { style: {
                            width: '30px',
                            height: '30px',
                            borderRadius: '5px',
                            marginInlineEnd: '1em',
                            backgroundColor: 'grey',
                        } }), _jsxs("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            flex: '1',
                        }, children: [_jsx("div", { style: {
                                    fontSize: '1em',
                                    fontWeight: 'bold',
                                    overflowWrap: 'break-word',
                                }, children: messages.subject }), _jsx("div", { style: {
                                    fontSize: '1em',
                                    marginBlockStart: '0.5em',
                                    marginBlockEnd: '0.5em',
                                    overflowWrap: 'break-word',
                                }, children: messages.plain })] })] }) }) }));
};
//# sourceMappingURL=push_notification.preview.component.js.map